<script>
export default {
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <!-- Aceleres 2026-09-04: `max-md:min-w-0` porque este bloco e filho de uma
       grelha, e filho de grelha tem `min-width:auto` — recusa-se a encolher
       abaixo do proprio conteudo. Bastava um nome de caixa de entrada comprido
       para ele medir 649px numa tela de 393 e arrastar a pagina inteira, com
       os 256px de diferenca cortados e fora de alcance. -->
  <div class="border-b border-solid border-n-weak/60 max-md:min-w-0">
    <div class="max-w-7xl w-full mx-auto pt-4 pb-0 px-6 max-md:min-w-0">
      <!-- Os nomes gerados pela Aceleres sao fichas unicas e longas, do tipo
           `access-modes-20260711203224-a57e49`, sem espaco onde partir. Sem
           isto e o titulo que fixa a largura da pagina. -->
      <h2 class="text-2xl text-n-slate-12 mb-1 font-medium max-md:break-words">
        {{ headerTitle }}
      </h2>
      <p v-if="headerContent" class="w-full text-n-slate-11 text-sm mb-2">
        {{ headerContent }}
      </p>
      <slot />
    </div>
  </div>
</template>
